export default "__VITE_ASSET__B532DJ6T__"